// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lPEN","question":"styles_question__1gtd7","description":"styles_description__2SI3E"};